module.exports = __webpack_public_path__ + "AvenirLTStd-Book.ecb0c2ae369ba2a89d9a.otf";


//////////////////
// WEBPACK FOOTER
// /Users/mohammed/Desktop/OldLaptop/www-data/www-data/htdocs/remoteApi-front/ng-app/src/assets/fonts/AvenirLTStd-Book.otf
// module id = ../../../../../src/assets/fonts/AvenirLTStd-Book.otf
// module chunks = styles